let vdo_player= document.getElementById('nexgiPlayer'); 
let vdoLink = document.getElementById('video_link').value;

function getVdoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
}

vdo_player.addEventListener('click',()=>{
 while (vdo_player.hasChildNodes()) {
    vdo_player.removeChild(vdo_player.firstChild);
  }
  var videoId = getVdoId(vdoLink);
  vdo_player.innerHTML= '<iframe src="//www.youtube.com/embed/'+ videoId +'?autoplay=1" width="100%" height="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>'
});